<template>
  <section class="policy-information">
    <housemaid-quote-info
      v-if="productId == 12"
      :title="false"
      :formData="form" />
    <travel-quote-info
      v-else-if="productId == 14"
      :title="false"
      :formData="form" />
    <decoration-quote-info
      v-else-if="productId == 15"
      :title="false"
      :formData="form" />
    <working-quote-info
      v-else-if="productId == 13"
      :title="false"
      :formData="form" ></working-quote-info>
    <student-quote-info
      v-else-if="productId == 16"
      :title="false"
      :formData="form">

    </student-quote-info>
    <homefire-quote-info
      v-else-if="productId == 17"
      :title="false"
      :formData="form" />
    <personal-quote-info
      v-else-if="productId == 18"
      :title="false"
      :formData="form" />
    <fire-quote-info
      v-else-if="productId == 20"
      :title="false"
      :formData="form" />
    <template v-else>
      <div class="table strip">
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ form.pcy_cmnt_dt }}</span>
        </div>
      </div>
      <template v-if="!isMotorTrade">
        <h2>Insured Vehicle</h2>
        <insured-vehicle-info :form="form" />
      </template>
      <h2>Policyholder Details</h2>
      <policy-holder-info :form="form" />
      <template v-if="!isMotorTrade||isMotorTrade&&!isTPlate">
        <h2>Named Driver Information</h2>
        <drivers-info
          :form="form"
          @open-driver="handlerOpenDriver" />
      </template>
    </template>
    <h2>Documents</h2>
    <document-form
      ref="document-form"
      :form="form"
      :currentDriversData="currentDriversData" />
  </section>
</template>
<script>
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from './info/policy-holder-info'
import DriversInfo from './info/drivers-info'
import DocumentForm from './document-form'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import personalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import {mapState} from 'vuex'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'

export default {
  name: 'PolicyInformamtion',
  components: {
    StudentQuoteInfo,
    WorkingQuoteInfo,
    InsuredVehicleInfo,
    PolicyHolderInfo,
    DriversInfo,
    DocumentForm,
    DecorationQuoteInfo,
    HousemaidQuoteInfo,
    HomefireQuoteInfo,
    fireQuoteInfo,
    TravelQuoteInfo,
    personalQuoteInfo
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentDriversData: []
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  methods: {
    async submitForm() {
      // if(this.productId==13||this.productId==16) return
      return await this.$refs['document-form'].submitForm()
    },
    // 記名司機同步
    handlerOpenDriver(data, list) {
      this.currentDriversData = data
    },
  }
}
</script>
